import { render } from "./userSelect.vue?vue&type=template&id=dae6480c&scoped=true"
import script from "./userSelect.vue?vue&type=script&lang=js"
export * from "./userSelect.vue?vue&type=script&lang=js"

import "./userSelect.vue?vue&type=style&index=0&id=dae6480c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae6480c"]])

export default __exports__